<template>
    <div style="width: 28.54vw;height: 24.5vh">
        <div style="display: flex;justify-content: space-between">
            <div style="position: relative">
                <div class="location">{{ environmentMonitor.location }}</div>
                <div style="color: #ffffff;text-align: left">{{ environmentMonitor.weather }}</div>
            </div>
            <div style="position: relative">
                <div class="overcast"></div>
                <div class="weatherDetail">{{ environmentMonitor.weather }}</div>
            </div>
        </div>
        <div style="display: flex;flex-wrap: wrap;justify-content: space-around;top: -0.5vh">
            <div class="container around-center" v-for="item, index of environmentMonitor.typeDetails" :key="index">
                <div class="typeName">{{ item.typeName }}</div>
                <div class="valueUnit">{{ item.value + item.unit }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'environmentMonitor',

    props: {
        environmentMonitor: {
            location: String,
            weather: String,
            typeDetails: [
                {
                    typeName: String,
                    value: Number || String,
                    unit: { type: String, default: () => ""},
                },
            ],
        },
    },

    components: {  },

    data() {
        return {}
    },

    mounted() {},

    methods: {},
}
</script>

<style lang="less">
.location {
    font-size: 18px;
    font-weight: normal;
    line-height: 30px;
    color: #01FFFD;
    text-align: left;
}

.weatherDetail {
    .location();
    position: absolute;
    right: 30px;
    bottom: 5px;
    font-size: 14px;
    color: #FFFFFF;
}

.weatherIcon {
    top: -2vh;
    width: 83px;
    height: 82px;
    z-index: 1;
}

.overcast {
    .weatherIcon();
    background: url('../../../../assets/image/homeTemp/overcast.png');
}

.container {
    width: 9vw;
    max-width: 140px;
    height: 42.39px;
    background: rgba(5, 77, 165, 0.01);
    box-sizing: border-box;
    border: 1px solid #01FFFD;
    box-shadow: inset 0px 4px 43px 0px #054DA5;
    margin-bottom: 1vh;
}

.typeName {
    font-size: 15px;
    font-weight: 500;
    color: #01FFFD;
}

.valueUnit {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
}
</style>
